import styles from "./Navbar.module.scss";
import { useContext, useEffect, useRef } from "react";
import NavContext from "../../context/NavContext";
import { NavLink } from "react-router-dom";
import {
  MdQueryStats,
  MdPeopleOutline,
  MdOutlineCompassCalibration,
  MdHelpCenter,
  MdOutlineManageAccounts,
  MdDownload,
  MdOutlineAdminPanelSettings,
  MdMenu,
} from "react-icons/md";
import { FcStatistics } from "react-icons/fc";
import { VscNotebookTemplate } from "react-icons/vsc";
import { AiOutlineTable, AiOutlineFileProtect } from "react-icons/ai";
import { FaMicrophoneAlt, FaFileAudio } from "react-icons/fa";
import { GrLicense, GrCertificate, GrUserManager } from "react-icons/gr";
import { RiBillLine } from "react-icons/ri";
import logo from "../../pics/logo-hearingspace.png";
import PrivilegeBlock from "./PrivilegeBlock";

const NavUrl = ({ url, icon, description }) => (
  <li className={styles.li_navlink}>
    <NavLink
      to={url}
      className={({ isActive }) => (isActive ? styles.active : undefined)}
    >
      {icon}
      <span className={styles.description}>{description}</span>
    </NavLink>
  </li>
);

const Navbar = () => {
  const { nav, setNav, superAdmin, user, supportTeam } =
    useContext(NavContext);

  const navbarRef = useRef();
  const hamburgerRef = useRef();



  const isPrivilegedUser = Boolean(superAdmin) || Boolean(supportTeam);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        nav &&
        navbarRef.current &&
        hamburgerRef.current &&
        !navbarRef.current.contains(event.target) &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setNav(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [nav, setNav]);

  return (
    <>
      {/* Hamburger */}
      <button
        ref={hamburgerRef}
        className={styles.hamburger_button}
        onClick={() => setNav(!nav)}
      >
        <MdMenu size={50} />
      </button>

      {/* Sidebar */}
      <aside
        ref={navbarRef}
        className={`${styles.navbar_container} ${nav ? styles.show_navbar : styles.hide_navbar
          }`}
      >
        <nav className={styles.scrollable_menu}>
          <ul className={styles.menu_container}>
            <PrivilegeBlock show={superAdmin || isPrivilegedUser}>
              <NavUrl
                url="/private/superAdmin"
                icon={<MdOutlineAdminPanelSettings />}
                description="Manage Cabines"
              />
              {/* <NavUrl url="/private/superAdmin/manageUsers" icon={<AiOutlineTable />} description="Manage Users" />
              <NavUrl url="/private/superAdmin/manageUsersLegacy" icon={<AiOutlineTable />} description="Manage Users Legacy" /> */}
              <NavUrl
                url="/private/superAdmin/manageUserPreset"
                icon={<VscNotebookTemplate />}
                description="Manage Preset"
              />
              <NavUrl
                url="/private/superAdmin/manageMics"
                icon={<FaMicrophoneAlt />}
                description="Manage Mics"
              />
              <NavUrl
                url="/private/superAdmin/diracLicence"
                icon={<GrLicense />}
                description="Dirac Licence"
              />
              <NavUrl
                url="/private/superAdmin/wordsLicence"
                icon={<FaFileAudio />}
                description="Words Licence"
              />
              <NavUrl
                url="/private/superAdmin/hearingspaceLicence"
                icon={<AiOutlineFileProtect />}
                description="HS Licence"
              />
              <NavUrl
                url="/private/superAdmin/manageCertificat"
                icon={<GrCertificate />}
                description="Manage Certificat"
              />
              <NavUrl
                url="/private/abonnements"
                icon={<RiBillLine />}
                description="Gestions des cabines"
              />
              <NavUrl
                url="/private/superAdmin/statistics"
                icon={<FcStatistics />}
                description="Statistics"
              />

              {superAdmin && (
                <NavUrl
                  url="/private/superAdmin/managePermissions"
                  icon={<GrUserManager />}
                  description="Manage Permissions"
                />
              )}
            </PrivilegeBlock>
            <NavUrl
              url="/private/dashboard"
              icon={<MdQueryStats />}
              description="Dashboard"
            />
            <NavUrl
              url="/private/calibration"
              icon={<MdOutlineCompassCalibration />}
              description="Certificat de calibration"
            />
            {!user && (
              <NavUrl
                url="/private/team"
                icon={<MdPeopleOutline />}
                description="Utilisateurs"
              />
            )}

            <NavUrl
              url="/private/download"
              icon={<MdDownload />}
              description="Téléchargements"
            />

            <NavUrl
              url="/private/mon-compte"
              icon={<MdOutlineManageAccounts />}
              description="Mon compte"
            />
            <NavUrl
              url="/private/faq"
              icon={<MdHelpCenter />}
              description="FAQ (Vidéos d'aide)"
            />
          </ul>
        </nav>

        {/* Logo */}
        <div className={styles.logo_container}>
          <img className={styles.logo} src={logo} alt="Logo Hearing Space" />
        </div>
      </aside>
    </>
  );
};

export default Navbar;
